import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

lessRequire('modules/shared/switch.less');

export default function Switch({ options, onSwitch, intl }) {
	return (
		<div className="header-switch">
			<div className="header-switch__links font-proxima-nova-semibold">
				{options.map((option, i) => (
					<a
						key={i}
						href="#"
						className={cn({ active: option.active })}
						onClick={e => {
							e.preventDefault();
							onSwitch(option.id);
						}}
					>
						{intl(option.title)}
					</a>
				))}
			</div>
		</div>
	);
}

Switch.propTypes = {
	options: PropTypes.array,
	onSwitch: PropTypes.func,
	intl: PropTypes.func
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/master-switch/main.js